import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createArbitratorDetailsAPI,
  updateArbitratorDetailsAPI,
  getArbitratorDetailsByCaseIDAPI,
  deleteArbitratorDetailsAPI,
} from "../../../api/arbitratorDetails_api";

export const getArbitratorDetailsByCaseIDAction = createAsyncThunk(
  "arbitratorDetails/getArbitratorDetailsByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getArbitratorDetailsByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createArbitratorDetailsAction = createAsyncThunk(
  "arbitratorDetails/createArbitratorDetails",
  async (arbitratorDetailsData, { rejectWithValue }) => {
    const response = await createArbitratorDetailsAPI(arbitratorDetailsData);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateArbitratorDetailsAction = createAsyncThunk(
  "arbitratorDetails/updateArbitratorDetails",
  async ({ arbitrator_ID, arbitratorDetailsData }, { rejectWithValue }) => {
    const response = await updateArbitratorDetailsAPI(
      arbitrator_ID,
      arbitratorDetailsData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteArbitratorDetailsAction = createAsyncThunk(
  "arbitratorDetails/deleteArbitratorDetails",
  async (arbitrator_ID, { rejectWithValue }) => {
    const response = await deleteArbitratorDetailsAPI(arbitrator_ID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
